import React from 'react';
import { useLanguage } from '@/contexts';
import { SmallCopyButton } from '../../shared/CopyButton';

interface SystemPromptDisplayProps {
  systemPrompt: string;
  onCopy: (text: string, type: string) => void;
  isVisible?: boolean;
}

// Simple section header component
const SectionHeader: React.FC<{ 
  title: string; 
  onCopy: () => void; 
  copyLabel: string;
}> = ({ title, onCopy, copyLabel }) => (
  <div className="flex items-center justify-between mb-2">
    <h3 className="text-sm font-medium text-gray-700 dark:text-slate-300">{title}</h3>
    <SmallCopyButton onCopy={onCopy} label={copyLabel} />
  </div>
);

// Simple content container component
const ContentContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-700 rounded-lg p-4">
    <div className="text-sm text-start text-gray-800 dark:text-slate-200">{children}</div>
  </div>
);

// Main system prompt display component
const SystemPromptDisplay: React.FC<SystemPromptDisplayProps> = ({ 
  systemPrompt, 
  onCopy,
  isVisible = true 
}) => {
  const { t } = useLanguage();

  if (!isVisible || !systemPrompt) return null;

  const handleCopy = () => onCopy(systemPrompt, 'System Message');

  return (
    <>
      <SectionHeader 
        title={t("systemPrompt")} 
        onCopy={handleCopy} 
        copyLabel={t("copy")}
      />
      <ContentContainer>
        {systemPrompt}
      </ContentContainer>
    </>
  );
};

export default SystemPromptDisplay;

// Export individual components for reuse
export { SectionHeader, ContentContainer };
